/*
 *
 *  FUNCTIONS
 *  contains basic js fot the entire website
 *  this file is always loaded on the bottom of the page
 *  !! Created by Ilse on 05/08/2016
 *
 */
$(document).ready(function () {

    //-- Get mini-cart
    $('div#mini-cart-container').mouseenter(function () {
        $('div.mini-cart-dropdown').html('<div class=\'wrap\'><div class=\'mini-cart-loader\'><img src=\'' + strPath + 'images/css/ajax-loader.gif\' alt=\'\' title=\'\' /></div></div>');

        $.post(strAjaxPath + 'cart/mini-cart.php', '', function (data) {
            $('div#mini-cart-container').replaceWith(data);
        }, 'html');
    });

    //-- Clicking on the cookie button
    $('div.cookies').click(function (e) {
        if ($(e.target).hasClass('btn')) {
            $(this).hide();
            $.post(strAjaxPath + 'cookies.php?type=' + $(e.target).data('type'), function () {
            });
        }
    });

    //-- Scroll
    $('a[data-scroll]').click(function () {
        $('html, body').animate({
            scrollTop: $('div[data-scroll-to="' + $(this).attr('data-scroll') + '"]').offset().top,
        }, 800);
    });

    //-- Show password
    $('img.show-password').on('click', function () {
        const input = $(this).prev();
        input.attr('type', (input.attr('type') === 'password') ? 'text' : 'password');
    });

    // 1. TOUCH OR NO TOUCH
    //check between touch and not touch
    function is_touch_device() {
        return (('ontouchstart' in window)
            || (navigator.MaxTouchPoints > 0)
            || (navigator.msMaxTouchPoints > 0));
    }

    // 2. make every link with rel=external work as a target _blank link
    // used instead of inline target blank for validation reasons
    $('a[rel=\'external\']').click(function () {
        $(this).attr('target', '_blank');
    });
    // 3. Menu slide toggle
    // when clicked on the link give the body an extra classe
    // slidetoggle is made with css (structure.scss)
    $('body').on('click', '.mobile-nav-toggle', function (evt) {
        $('body').toggleClass('menu-open');
        $('.product-nav').toggleClass('d-none');
        evt.stopImmediatePropagation();
        return false;
    });

    /*  $('.toggle-filters').on('click touchstart', function () {
          $('body').toggleClass('filters-open');
          return false;
      });*/

    if (is_touch_device()) {
        // if touch device no hover but click, only on devices larger then 768, smaller is link through
        if ($(window).width() >= 768) {
            $('div.mini-cart > a').on('click touchstart', function () {
                $('div.mini-cart').toggleClass('showsub');
                return false;
            });
        }
    }

    //get the head navigaiton to work on click on touch devices
    if ($(window).width() >= 992) {
        if (is_touch_device()) {
            //click on a headnavigation item
            $('nav.navigation ul li a.sublink').each(function () {
                $(this).on('click touchstart', function () {
                    if ($(this).parent().hasClass('hover')) {
                        var href = $(this).attr('href');
                        window.location.href = href;

                    } else {
                        $('nav.navigation ul li').removeClass('hover');
                        $(this).parent().addClass('hover');
                        return false;
                    }
                });
            });

            // When clicked outside of the li-items: remove every 'hover' class on the li-elements
            $('body').on('click touchstart', function (event) {
                if (!$(event.target).is('nav.navigation ul, nav.navigation ul li, nav.navigation ul li a')) {
                    $('nav.navigation ul, nav.navigation ul li').removeClass('hover');
                }
            });
        }
    }

    // Fancybox
    $('[data-fancybox], a.fancybox').fancybox({
        hash: false,
        backFocus: false,
        animationEffect: 'fade',
        thumbs: {
            autoStart: true,
        },
        buttons: [
            'thumbs',
            'close',
        ],
    });

    //--Filter on news
    $('form.search.news select').on('change', function () {
        $(this).closest('form').submit();
    });

    // Popup exit intent
    if ($('#popup-exit-intent').length) {
        const mouseEvent = e => {
            const shouldShowExitIntent =
                !e.toElement &&
                !e.relatedTarget &&
                e.clientY < 10;

            if (shouldShowExitIntent) {
                document.removeEventListener('mouseout', mouseEvent);
                document.querySelector('.close-custom-popup').addEventListener('click', exit);
                document.querySelector('.popup-overlay').addEventListener('click', exit);
                document.querySelector('.popup-exit').classList.add('active');
                document.cookie = "popupExit=true; path=/";
            }
        };

        const exit = e => {
            document.querySelector('.popup-exit').classList.remove('active');
        };

        document.addEventListener('mouseout', mouseEvent);
    }
});

// Limit counter (for limit on textarea)
// Used for: the giftcard
function UpdateCountdown(objMessage, objCountdown, intLimit, strLabel) {
    var intRemaining = intLimit - objMessage.val().length;
    // Make sure you can't go over the max. number of characters
    if (intRemaining <= 0) {
        objMessage.val(objMessage.val().substr(0, intLimit));
        intRemaining = 0;
    }

    // Notification
    objCountdown.text(strLabel.replace('[NUMBER]', intRemaining));
}

// Html entity decode (for special characters)
// Used for: Ajax response
function html_entity_decode(str) {
    try {
        var tarea = document.createElement('textarea');
        tarea.innerHTML = str;
        return tarea.value;
        tarea.parentNode.removeChild(tarea);
    } catch (e) {
        //for IE add<div id="htmlconverter" style="display:none;"></div> to the page
        document.getElementById('htmlconverter').innerHTML = '<textarea id="innerConverter">' + str + '</textarea>';
        var content = document.getElementById('innerConverter').value;
        document.getElementById('htmlconverter').innerHTML = '';
        return content;
    }
}

// local and session storage
// Used for: the wishlist
function GetLocalStorage(strName) {
    var strItem = '';

    if (typeof (Storage) !== 'undefined' && localStorage[strName]) {
        strItem = localStorage.getItem(strName);
    }

    return strItem;
}

function SetLocalStorage(strName, strValue) {
    if (typeof (Storage) !== 'undefined') {
        localStorage.setItem(strName, strValue);
    }
}

function GetSessionStorage(strName) {
    var strItem = '';

    if (typeof (Storage) !== 'undefined' && sessionStorage[strName]) {
        strItem = sessionStorage.getItem(strName);
    }

    return strItem;
}

function SetSessionStorage(strName, strValue) {
    if (typeof (Storage) !== 'undefined') {
        sessionStorage.setItem(strName, strValue);
    }
}

window.SetSessionStorage = SetSessionStorage;
window.GetSessionStorage = GetSessionStorage;
window.SetLocalStorage = SetLocalStorage;
window.GetLocalStorage = GetLocalStorage;
window.html_entity_decode = html_entity_decode;
window.UpdateCountdown = UpdateCountdown;
